import { AstraButton, AstraParagraph, astraTwMerge } from '~/astra'

import { AvatarTypeIcon } from './InboxList'

const PlaceholderMessageContent = () => (
    <div className="flex gap-3">
        <div className="relative h-10 w-10 self-start rounded-full bg-neutral-subtle-rest">
            <span className="absolute -right-1 bottom-[-6px] rounded-full border border-focus-inner bg-neutral-subtle-rest">
                <AvatarTypeIcon inboxType={'user.mentioned'} grayScale />
            </span>
        </div>
        <div className="flex flex-col items-start justify-between gap-4">
            <div className="flex items-center gap-2">
                <div className="h-3 w-3 rounded-full bg-neutral-subtle-rest" />
                <div className="h-3 w-28 rounded-full bg-neutral-subtle-rest" />
                <div className="h-3 w-8 rounded-full bg-neutral-subtle-rest opacity-70" />
            </div>
            <div className="flex w-full flex-col gap-2">
                <div className="h-3 w-full rounded-full bg-neutral-subtle-rest opacity-80" />
                <div className="h-3 w-11/12 rounded-full bg-neutral-subtle-rest opacity-70" />
            </div>
        </div>
    </div>
)

const PlaceholderMessage = ({ className, backgroundLayers = 0 }: { className?: string; backgroundLayers?: number }) => (
    <div className={astraTwMerge('relative -rotate-6', className)} aria-hidden>
        {Array.from({ length: backgroundLayers }).map((_, i) => (
            <div
                key={i}
                className="absolute inset-0 rounded-xl border border-subtle bg-surface-base shadow-sm"
                style={{
                    transform: `translate(${(i + 1) * -12}px, ${(i + 1) * 12}px)`,
                    opacity: 0.9 - i * 0.1,
                    zIndex: -1 - i,
                }}
            />
        ))}
        <div className="rounded-xl border border-strong bg-surface-base p-3">
            <PlaceholderMessageContent />
        </div>
    </div>
)

export const EmptyInboxList = ({ showAllClick }: { showAllClick?: () => void }) => (
    <div className="flex w-full max-w-[460px] flex-col items-center justify-center gap-4 px-4 py-12 text-center">
        <div className="flex w-full items-center justify-center pb-8">
            <PlaceholderMessage backgroundLayers={2} />
        </div>
        <AstraParagraph className="text-muted">Her var det tomt</AstraParagraph>
        {showAllClick && <AstraButton onClick={showAllClick} label="Vis alle" variant="secondary" />}
    </div>
)
